<template lang="pug">
  .Profile(v-if="PAGE_SHOW")

    ExpandableBox.password(
      :title="$t('profile.misc.title_password')"
      :startExpanded="true"
      :expandable="false"
    )
      form(
        autocomplete="off"
        data-vv-scope="formPassword")

        .col.col-full
          FormItem(
            type="password"
            field_name="old_password"
            v-model="old_password"
            :validate="true"
            :label_text="$t('profile.field.old_password')"
            :data-vv-as="$t('profile.field.old_password')"
            v-validate="'required|min:6'"
            :error="veeErrors.first('formPassword.old_password')")

        .col.col-full
          FormItem(
            type="password"
            field_name="new_password"
            v-model="new_password"
            :validate="true"
            :label_text="$t('profile.field.new_password')"
            :data-vv-as="$t('profile.field.new_password')"
            v-validate="'required|min:6'"
            :error="veeErrors.first('formPassword.new_password')")
      .footer
        button.btn.btn-primary(
          type="button"
          @click="savePassword"
        ) {{ this.$t('profile.action.change_password') }}

</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import ExpandableBox from '@/component/expandable-box'


  export default {
    name: 'Profile',

    components: {
      ExpandableBox
    },

    data () {
      return {
        old_password: null,
        new_password: null,
        loading: false,
        PAGE_SHOW: false
      }
    },
    computed: {
      ...mapState([]),
    },
    methods: {
      ...mapActions('Profile', [
        'updatePassword'
      ]),

      async savePassword () {
        try {
          const isValid = this.$validator.validateAll('formPassword')
          if (!isValid)
            return

          this.loading = true
          await this.updatePassword({
            old_password: this.old_password,
            new_password: this.new_password
          })

          this.showSuccessToast(this.$t('profile.msg.password_update_message'))
          this.$validator.pause()
          this.old_password = ''
          this.new_password = ''
          setTimeout(() => {
            this.$validator.resume()
          }, 0)
        } catch (err) {
          this.showErrorToast(this.$getErrorMessage(this, err))
        } finally {
          this.loading = false
        }
      }
    },

    mounted () {
      this.old_password = null
      this.new_password = null
      this.PAGE_SHOW = true
    }
  }
</script>

<style lang="scss" scoped>
.Profile {
  display: flex;
  flex-direction: column;
  align-items: center;

  .password {
    margin-top: 24px;
  }

  form {
    display: grid;
    width: 1000px;
    grid-template-columns: repeat(auto-fill, calc(50% - 10px));
    grid-column-gap: 20px;
    grid-row-gap: 30px;

    @media only screen and (max-width: 1439px) {
      width: 600px;
    }

    .col-full {
      grid-column: 1/3;
    }
  }

  .footer {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 30px;
  }

  /deep/ {
    .ExpandableBox {
      .top {
        height: auto;
      }
    }
  }
}


  </style >
